import { type ReactNode } from "react";
import { XIcon } from "lucide-react";

import { Column, Text } from "@/components";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const EnrichmentInputCard = ({
  description,
  icon,
  iconClassName,
  onClick,
  onRemove,
  title,
}: {
  description: string;
  icon: ReactNode;
  iconClassName?: string;
  onClick: () => void;
  onRemove?: () => void;
  title: string;
}) => {
  /* Render */
  const render = () => {
    return (
      <div className="relative">
        <Button
          className="flex h-[120px] w-full flex-col items-start justify-between rounded-2xl border border-slate-100 bg-white p-3 text-left shadow-sm transition-shadow hover:bg-white hover:text-slate-700 hover:shadow-md"
          onClick={onClick}
          variant="ghost"
        >
          <div
            className={cn(
              "flex h-10 w-10 items-center justify-center rounded-xl bg-slate-100 text-slate-700",
              iconClassName,
            )}
          >
            {icon}
          </div>
          <Column className="w-full items-start gap-0">
            <Text
              className="w-full truncate text-sm font-semibold text-slate-900"
              truncate
            >
              {title}
            </Text>
            <Text className="w-full truncate text-xs" truncate variant="muted">
              {description}
            </Text>
          </Column>
        </Button>
        {onRemove && (
          <Button
            aria-label={`Remove ${title}`}
            className="absolute right-2 top-2 h-6 w-6 rounded-full bg-white p-0 text-slate-500 shadow-sm hover:bg-slate-50 hover:text-slate-900"
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            size="icon"
            variant="ghost"
          >
            <XIcon />
          </Button>
        )}
      </div>
    );
  };

  return render();
};
